<template>
  <tr class="category">
    <td class="subheading" :colspan="isKpiHidden ? 4 : 5"><h3>{{ sequence }}. {{ title }}</h3></td>
    <td class="text-xs-center body-2 subheading"><b>{{ count | printFloat }} ({{ countK | printFloat }})</b></td>
    <td class="text-xs-center body-2 subheading"><b>{{ award | printFloat }} ({{ awardK | printFloat }})</b></td>
    <td class="text-xs-center body-2 subheading"><b>{{ counted | printFloat }} ({{ countedK | printFloat }})</b></td>
    <td></td>
  </tr>
</template>

<script>
import { printFloat } from "@/plugins/helpers"

export default {
  name: 'CategoryIndicator',
  filters: {
    printFloat
  },
  props: {
    sequence: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    isKpiHidden: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0
    },
    award: {
      type: Number,
      default: 0
    },
    counted: {
      type: Number,
      default: 0
    },
    countK: {
      type: Number,
      default: 0
    },
    awardK: {
      type: Number,
      default: 0
    },
    countedK: {
      type: Number,
      default: 0
    }
  }
}
</script>
